import axios from 'axios'
// Notification
import {  MessageBox, Message } from 'element-ui'
// import store from '@/store'
import { getToken, removeToken } from '@/utils/auth'
import errorCode from '@/utils/src/errorCode'
import { tansParams } from "@/utils/src/tansParams";
import qs from 'qs'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: global.$config.api.base_url,
    // 超时
    timeout: 20000
})

// request拦截器
service.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    if (getToken() && !isToken) {
        config.headers['accessToken'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded'

    }
    if (config.headers?.ignoreValidate) {
        config.headers['ignoreValidate'] = true;
    }
    // formDate
    // if (config.method === 'post' && config.data) {
    //     config.data = qs.stringify(config.data)
    // }
    // if (config.url.indexOf('export') > 0) {
    //     console.log(config.url)
    //     config.responseType = 'blob'
    // }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    if(config.data && config.data.isFormData != undefined && config.data.isFormData){
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        delete config.data.isFormData
        config.data = qs.stringify(config.data)
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    console.log(res)
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || res.data.message || errorCode['default']
    if (code === 401 || code === 1 || code === 100000 || code === 100040 || code === 100050) {
        MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
        }
        ).then(() => {
            removeToken();
            location.href = '/';
            window.ZJApp.ZJUser.prototype.logout();

        }).catch(() => { });
        return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
        Message({
            message: msg,
            type: 'error'
        })
        return Promise.reject(new Error(msg))
    } else if (code !== 200&&code!=="00000") {
        Message({
            message: msg,
            type: 'error'
        })
        return Promise.reject('error')
    } else {
        return res.data
    }
},
    error => {
        console.log('err' + error)
        let { message } = error;
        if (message == "Network Error") {
            message = "后端接口连接异常";
        }
        else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        }
        else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

// 通用下载方法：post方式
export function bigDatadDownload(url, params, filename, type = 'application/zip') {
    return service.post(url, params, {
        transformRequest: [(params) => {
            return tansParams(params)
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        responseType: 'blob'
    }).then((data) => {
        const content = data
        const blob = new Blob([content], { type })
        if ('download' in document.createElement('a')) {
            const elink = document.createElement('a')
            elink.download = filename
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
        } else {
            navigator.msSaveBlob(blob, filename)
        }
    }).catch((r) => {
        console.error(r)
    })
}

// 通用下载方法：get方式
export function bigDatadDownload2(url, filename, type = 'application/zip') {
    return service.get(url, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        responseType: 'blob'
    }).then((data) => {
        const content = data
        const blob = new Blob([content], { type })
        if ('download' in document.createElement('a')) {
            const elink = document.createElement('a')
            elink.download = filename
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
        } else {
            navigator.msSaveBlob(blob, filename)
        }
    }).catch((r) => {
        console.error(r)
    })
}

export default service
